import {
  useScopedUiCollection,
  type ScopedUiParams,
} from "@/hooks/useScopedUiStorage";
import {
  EMPTY_UI_COMPONENTS,
  getUiComponentsSnapshot,
  subscribeUiComponents,
  type StoredUiComponent,
} from "@/storage/uiComponentsRepository";
import {
  EMPTY_UI_COMPONENT_SPECS,
  getUiComponentSpecsSnapshot,
  subscribeUiComponentSpecs,
  type StoredUiComponentSpec,
} from "@/storage/uiComponentSpecsRepository";
import {
  EMPTY_UI_SIDEBAR_ITEMS,
  getUiSidebarItemsSnapshot,
  subscribeUiSidebarItems,
  type StoredUiSidebarItem,
} from "@/storage/uiSidebarItemsRepository";

export type DynamicSidebarItemsParams = ScopedUiParams;

interface UseDynamicSidebarItemsResult {
  items: readonly StoredUiSidebarItem[];
}

interface UseUiComponentsResult {
  components: readonly StoredUiComponent[];
}

export function useDynamicSidebarItems(
  params: DynamicSidebarItemsParams,
): UseDynamicSidebarItemsResult {
  const items = useScopedUiCollection({
    emptySnapshot: EMPTY_UI_SIDEBAR_ITEMS,
    getSnapshot: getUiSidebarItemsSnapshot,
    params,
    subscribe: subscribeUiSidebarItems,
  });

  return { items };
}

export function useUiComponents(
  params: DynamicSidebarItemsParams,
): UseUiComponentsResult {
  const components = useScopedUiCollection({
    emptySnapshot: EMPTY_UI_COMPONENTS,
    getSnapshot: getUiComponentsSnapshot,
    params,
    subscribe: subscribeUiComponents,
  });

  return { components };
}


export function useUiComponentSpecs(
  params: DynamicSidebarItemsParams,
): readonly StoredUiComponentSpec[] {
  return useScopedUiCollection({
    emptySnapshot: EMPTY_UI_COMPONENT_SPECS,
    getSnapshot: getUiComponentSpecsSnapshot,
    params,
    subscribe: subscribeUiComponentSpecs,
  });
}
